import axios from "axios";

import { TTP_API_URL } from "../config";

export const runAdminIsTaskSynchronisation = ({
  token,
  organization,
  year,
  period,
  clientErpId,
  collaboratorErpId
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_tasks_sync`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("year", year);
  formData.append("period", period);
  formData.append("clientErpId", clientErpId ?? "");
  formData.append("collaboratorErpId", collaboratorErpId ?? "");
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};
export const runAdminIsInvoiceSynchronisation = ({
  token,
  organization,
  year,
  period,
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_invoices_sync`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("year", year);
  formData.append("period", period);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};
export const runAdminIsTvaBalancesSynchronisation = ({
  token,
  organization,
  year,
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_tva_balances_sync`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};
export const runAdminIsBalancesSynchronisation = ({
  token,
  organization,
  year,
  type,
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_balances_sync`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("year", year);
  formData.append("type", type);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};
export const runAdminIsClientRolesSynchronisation = ({
  token,
  organization,
  year,
  clientErpId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_client_roles`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("clientErpId", clientErpId);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};
export const runAdminIsClientsSynchronisation = ({
  token,
  organization,
  year,
  clientErpId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/adminis/clients-synchro`;

  let formData = new FormData();
  formData.append("organizationId", organization);
  formData.append("clientErpId", clientErpId);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const runAdminIsEncodageSynchronisation = ({
  token,
  organization,
  year
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_encodage_sync`;

  let formData = new FormData();
  formData.append("organizationId", organization);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const runAdminIsClientEntitiesSynchronisation = ({
  token,
  organization,
  year,
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_client_entities_sync`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const runAdminIsInvoicePlanningSynchronisation = ({
  token,
  organization,
  year,
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_invoice_planning_sync`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const sendTimeSheetReminders = ({ token, organization }) => {
  const requestUrl = `${TTP_API_URL}/team/adminis/timesheet-reminder`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const runAdminIsClientParametersSynchronisation = ({
  token,
  organizationId,
  year,
  clientErpId,
}) => {
  const requestUrl = `${TTP_API_URL}/team/adminis/clients-parameters`;

  let formData = new FormData();
  formData.append("organizationId", organizationId);
  formData.append("clientErpId", clientErpId);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const sendTimeSheetCollaboratorReminder = ({
  token,
  organization,
  collaborator,
}) => {
  const requestUrl = `${TTP_API_URL}/team/adminis/timesheet-reminder/collaborator`;

  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("collaborator", collaborator);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};

export const runAdminIsCollaboratorSynchronisation = ({
  token,
  organization,
  year
}) => {
  const requestUrl = `${TTP_API_URL}/team/admin_is_collaborator_sync`;

  let formData = new FormData();
  formData.append("organizationId", organization);
  formData.append("year", year);
  formData.append("access_token", token);

  return axios.post(requestUrl, formData);
};
